import React, { useState, useEffect } from "react";
import NumericInput from "react-numeric-input";
import ImageZoomViewer from "./ProductImageZoomViewer";
import Global from "./Global";
import Modal360Viewer from "./Product360Viewer";
import ProductApplications from ".//ProductApplications";
import { numberFormat } from "../repository";

const CartItem = (props) => {
  const [item] = useState(props.item);
  const [index] = useState(props.item.index);
  const [spinnerValue, setSpinnerValue] = useState(item.Cantidad);
  const [inventario] = useState(item.Inventario);
  const [is360, set360] = useState(false);
  const [isModal360Open, setIsModal360Open] = useState(false);
  const [isImageZoom, setIsImageZoom] = useState(false);
  const [codeSelected, setCodeSelected] = useState(null);
  const [imageSource, setImageSource] = useState("");

  const openImageZoomModal = (e) => {
    e.preventDefault();
    if (imageSource !== Global.foto_nd) {
      setIsImageZoom(true);
    }
  };

  function openAppsModal(e) {
    e.preventDefault();
    setCodeSelected(item);    
  }

  const closeAppsModal = () => {
    setCodeSelected(null);
  };

  const open360Modal = (e) => {
    e.preventDefault();
    setIsModal360Open(true);
  };

  const close360Modal = () => {
    setIsModal360Open(false);
  };
  const checkImageExists = (url) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = url;
    });
  };

  useEffect(() => {
    let cancelled = false;

    const loadImages = async () => {
      const codigo = props.item.Codigo;
      const fotoUrl = Global.fotos_URL + codigo.toLowerCase().replace(/-/g, "_") + ".jpg";
      const foto360Url = Global.urlFotos360 + codigo.toUpperCase() + "/images/img_0_0_0.jpg";

      const [fotoExists, foto360Exists] = await Promise.all([
        checkImageExists(fotoUrl),
        checkImageExists(foto360Url),
      ]);

      if (!cancelled) {
        setImageSource(fotoExists ? fotoUrl : Global.foto_nd);
        set360(foto360Exists);
      }
    };

    loadImages();

    return () => { cancelled = true; };
  }, [props.item.Codigo]);

  const renderInventory = () => {
    if (inventario === -1) return null;
    const diff = inventario - spinnerValue;
    let badgeClass, label;
    if (diff >= 0 && diff > 10) {
      badgeClass = "badge-success"; label = "Disponible";
    } else if (diff >= 0) {
      badgeClass = "badge-warning"; label = "Bajo";
    } else {
      badgeClass = "badge-danger"; label = "No Disponible";
    }
    return (
      <span>
        <small className="text-muted">Inv:&nbsp;</small>
        <span className={"badge " + badgeClass} style={{ fontSize: "0.75rem" }}>{label}</span>
      </span>
    );
  };

  const closeImageZoomModal = () => {
    setIsImageZoom(false);
  };

  return (
    <li className="list-group-item cart-item-compact">
      <div className="row align-items-center">
        <div className="col-md-2 text-center">
          <img
            className="card-img-top"
            style={{
              cursor: "pointer",
              maxWidth: "100%",
              height: "100px",
              objectFit: "contain",
            }}
            src={imageSource}
            alt={props.item.Codigo}
            onClick={(e) => openImageZoomModal(e)}
            data-toggle="modal"
            data-target={"#modalImageZoom" + props.item.Codigo}
          />
          <div className="text-center mt-1">
            {isImageZoom && (
              <ImageZoomViewer
                item={props.item}
                imageSource={imageSource}
                closeModal={closeImageZoomModal}
              />
            )}
            {codeSelected && (
              <ProductApplications
                codigo={item.Codigo}
                closeModal={closeAppsModal}
              />
            )}
            <button
              className="btn btn-outline-warning btn-sm rounded-pill mr-1"
              style={{ fontSize: "0.7rem", padding: "2px 8px" }}
              onClick={(e) => openAppsModal(e)}
              data-toggle="modal"
              data-target={"#modalApps" + item.Codigo}
            >
              APS
            </button>
            {is360 && (
              <button
                type="button"
                className="btn btn-outline-info btn-sm rounded-pill"
                style={{ fontSize: "0.7rem", padding: "2px 8px" }}
                onClick={(e) => open360Modal(e)}
                data-toggle="modal"
                value="360"
                data-target={"#modal360" + item.Codigo + item.index}
              >
                360
              </button>
            )}
            {isModal360Open && (
              <Modal360Viewer
                index={index}
                item={item}
                catalogo={true}
                closeModal={close360Modal}
              />
            )}
          </div>
        </div>
        <div className="col-md-7">
          <div className="d-flex align-items-center">
            <span className="badge badge-secondary mr-2" style={{ fontSize: "0.9rem" }}>
              {item.Codigo}
            </span>
            {renderInventory()}
          </div>
          <span className="text-muted" style={{ fontSize: "0.95rem" }}>
            {item.Descripcion
              ? item.Descripcion
              : item.Familia +
                " / " +
                item.Marca +
                " / " +
                item.TipoVehiculo +
                " / " +
                item.Modelo +
                " / " +
                item.Posicion +
                " / " +
                item.Condicion}
          </span>
          <div className="d-flex align-items-center mt-2">
            <NumericInput
              name="spinner"
              key={item.idProducto}
              min={1}
              max={999}
              value={spinnerValue}
              size={5}
              mobile={true}
              onChange={(value) => {
                setSpinnerValue(
                  isNaN(Number.parseInt(value)) ? 1 : Number.parseInt(value),
                  props.update(
                    item,
                    isNaN(Number.parseInt(value)) ? 1 : Number.parseInt(value)
                  )
                );
              }}
              maxLength={3}
              style={{
                "btnUp.mobile": {
                  width: "4.0ex",
                  bottom: 2,
                  boxShadow: "none",
                  borderRadius: 2,
                  borderWidth: 1,
                },
                "btnDown.mobile": {
                  width: "4.0ex",
                  bottom: 2,
                  left: 2,
                  top: 2,
                  right: "auto",
                  boxShadow: "none",
                  borderRadius: 2,
                  borderWidth: 1,
                },
              }}
            />
            <button
              className="btn btn-secondary btn-sm ml-3"
              type="button"
              onClick={() => props.remove(item)}
            >
              <i className="fas fa-trash"></i>
            </button>
          </div>
        </div>
        <div className="col-md-3 text-right">
          <span className="badge badge-pill badge-primary" style={{ fontSize: "1rem" }}>
            ${numberFormat(item.PrecioPesosMayoreo)}
          </span>
        </div>
      </div>
    </li>
  );
};

export default CartItem;
